import type { Issue } from "./constants";

type StateMappings = {
	planned: string[];
	inProgress: string[];
	completed: string[];
};

export function validateIssuesByState(
	issues: Issue[],
	stateMappings: StateMappings,
): Issue[] {
	return issues.filter((issue) => {
		const state = issue.state.name.toLowerCase();
		return Object.values(stateMappings).some((states) =>
			states.some((s) => s.toLowerCase() === state),
		);
	});
}

export function getRoadmapSection(
	state: string,
	stateMappings: StateMappings,
): "planned" | "inProgress" | "completed" {
	const normalizedState = state.toLowerCase();

	if (
		stateMappings.planned.some(
			(s: string) => s.toLowerCase() === normalizedState,
		)
	) {
		return "planned";
	}

	if (
		stateMappings.inProgress.some(
			(s: string) => s.toLowerCase() === normalizedState,
		)
	) {
		return "inProgress";
	}

	if (
		stateMappings.completed.some(
			(s: string) => s.toLowerCase() === normalizedState,
		)
	) {
		return "completed";
	}

	// Default to planned if state doesn't match any known states
	return "planned";
}

export function organizeIssuesBySection(
	issues: Issue[],
	stateMappings: StateMappings,
) {
	const organizedIssues = {
		completed: [] as Issue[],
		inProgress: [] as Issue[],
		planned: [] as Issue[],
	};

	for (const issue of issues) {
		const section = getRoadmapSection(issue.state.name, stateMappings);
		organizedIssues[section].push(issue);
	}

	return organizedIssues;
}

export function sortIssuesByPriority(a: Issue, b: Issue) {
	if (a.priority == null) {
		return 1;
	}
	if (b.priority == null) {
		return -1;
	}
	const aPriority = a.priority === 0 ? 5 : a.priority;
	const bPriority = b.priority === 0 ? 5 : b.priority;
	return aPriority - bPriority;
}
